<template>
  <div id="project-page">
    <div class="project_details-section section-padding">
      <div class="container">
        <div class="row mt-5 mb-5">
          <div class="col-xl-12">
            <div
              class="images"
              v-viewer="{
              toolbar: true,
              title: true,
              navbar: true,
              fullscreen: true,
              movable: true,
              transition: true,
              button: true,
              play: true
              }"
              >   
              <!-- Image principale -->
              <img
                v-if="article && article.urlImage && isImage(article.urlImage)"
                :src="getUrlApiForFiles(article.urlImage)"
                class="medias"
                alt="Image principale"
              />

              <!-- Images secondaires -->
              <img
                v-for="media in medias"
                :key="media.id"
                :src="getUrlApiForFiles(media.type)"
                class="medias"
                alt="Image de l'article"
              />
          </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import ApiService from '@/services/ApiService';
import { useRoute } from 'vue-router';
import { getUrlApiForFiles } from '@/utils/utils';

interface Article {
  id: number;
  titre: string;
  sousTitre: string;
  urlImage?: string;
  contenu: string;
  datePublication: Date;
  nbrupload: number;
  categorieArticle?: {
    id: number;
    nom: string;
  };

}

interface Media {
  id: number;
  type: string;
  description: string;
  articleId: number;
}

const route = useRoute();
const article = ref<Article | null>(null);
const medias = ref<Media[]>([]);
const currentMediaIndex = ref(0);
const showModal = ref(false);
const currentImage = ref('');

// const API_IMAGE_BASE_URL = 'http://localhost:3001/uploads/';

function getImageUrl(filename?: string): string {
  if (!filename) return '';
  return `${ApiService.vueInstance.axios.defaults["updateUrl"]}uploads/${filename}`;
}

// Détection des types de médias
function isImage(filename: string): boolean {
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(filename);
}
function isVideo(filename: string): boolean {
  return /\.(mp4|webm|ogg)$/i.test(filename);
}
function isPdf(filename: string): boolean {
  return /\.pdf$/i.test(filename);
}

//  Gestion modale (images uniquement)
function open(url: string) {
  currentImage.value = url;
  showModal.value = true;
}
function openImage(url: string, index: number) {
  currentImage.value = url;
  currentMediaIndex.value = index;
  showModal.value = true;
}
function nextImage() {
  if (!medias.value.length) return;
  currentMediaIndex.value =
    (currentMediaIndex.value + 1) % medias.value.length;
  currentImage.value = getImageUrl(medias.value[currentMediaIndex.value].type);
}
function prevImage() {
  if (!medias.value.length) return;
  currentMediaIndex.value =
    (currentMediaIndex.value - 1 + medias.value.length) % medias.value.length;
  currentImage.value = getImageUrl(medias.value[currentMediaIndex.value].type);
}
function closeModal() {
  showModal.value = false;
}

async function fetchArticleById(articleId: string | number) {
  const response = await ApiService.get(`/articles/${articleId}`);
  article.value = response.data.data;
}
async function fetchMedias(articleId: number) {
  const response = await ApiService.get(`/articles/medias/${articleId}`);
  medias.value = response.data.data || [];
  console.log("ggg",medias.value)
}

onMounted(async () => {
  await fetchArticleById(route.params.id as string);
  if (article.value) await fetchMedias(article.value.id);
});
</script>
<style>
.single-image-wrapper {
  margin-bottom: 30px;
  text-align: center;
}

.article-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
}


.medias {
  height: 200px;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.media:hover {
  transform: scale(1.03);
}
.images {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* 4 images par ligne */
  gap: 20px;
  /* espace entre les images */
}
 


</style>